import { ILead } from "../../models/Lead";
import { IVehicle } from "../../models/Vehicle";


export default function VehicleJobsTableCell({ lead, vehicle }: { lead: ILead, vehicle: IVehicle }) {

  return (
    <div className="flex flex-col gap-y-2 text-sm">
      <p className="font-semibold">Jobs: {vehicle?.jobCount ?? 0} - Total Parts: {lead?.jobs?.[0]?.jobPartCount ?? 0}</p>

      <p className="text-xs">Awaiting Dismantling: {lead?.jobs?.[0]?.awaitingDismantlingPartCount ?? 0}</p>
      <p className="text-xs">Sold: {vehicle?.soldPartCount ?? 0}</p>
      <p className="text-xs">Available Parts: {vehicle?.availablePartCount ?? 0}</p>
    </div>
  )
}